/* eslint-disable */
// Global cache for internal voxels: colors is Uint16Array storing (colorIndex + 1); 0 means not internal
let internalVoxels = { colors: null, size: { x: 0, y: 0, z: 0 } };

// blkId = '0', '1', '2', '2X', '2L', '3', '3X', '4', '4X'
// data = [[x,y,z,c,connectivity,blkId,rotateX,rotateY,rotateZ,show,direction]...]
const BLKData = {
	data: {},
	size: {
		x: 0,
		y: 0,
		z: 0
	}
}

// blkId = '4', '4X'
// blkId = 'X1', 'X2', 'X3', 'X4'
// data = [[x,y,z,c,blkId,show,direction]...]
const BLOCKData = {
	data: {},
	size: {
		x: 0,
		y: 0,
		z: 0
	}
}

// 获取积木模型数据
export function getBLOCKData(chunk, defaultBlkId = '4') {
	const data = chunk.data;
	const size = chunk.size;
	
	BLOCKData.data = {};
	BLOCKData.size = { ...size };

	// 创建体素占用数组
	const offsety = size.x;
	const offsetz = size.x * size.y;
	const voxelArray = new Uint8Array(size.x * size.y * size.z);
	for (let i = 0; i < data.length; i += 4) {
		const x = data[i], y = data[i+1], z = data[i+2];
		const index = x + y * offsety + z * offsetz;
		voxelArray[index] = 255;
	}

	for (let i = 0; i < data.length; i += 4) {
		const x = data[i], y = data[i+1], z = data[i+2], c = data[i+3];
		const show = 1;
		BLOCKData.data[`${x},${y},${z}`] = [c, defaultBlkId, show, ''];
	}

	return BLOCKData;
}
// 获取BLK积木模型数据
export function getBLKData(chunk) {
	const data = chunk.data;
	const size = chunk.size;
	
	// 重置BLKData
	BLKData.data = {};
	BLKData.size = { ...size };
	
	// 创建体素占用数组
	const offsety = size.x;
	const offsetz = size.x * size.y;
	const voxelArray = new Uint8Array(size.x * size.y * size.z);
	
	// 填充体素占用数组
	for (let i = 0; i < data.length; i += 4) {
		const x = data[i], y = data[i+1], z = data[i+2];
		const index = x + y * offsety + z * offsetz;
		voxelArray[index] = 255;
	}
	
	// 逐层分析体素
	for (let z = 0; z < size.z; z++) {
		const layerVoxels = [];
		
		// 收集当前层的体素
		for (let i = 0; i < data.length; i += 4) {
			const x = data[i], y = data[i+1], voxelZ = data[i+2], c = data[i+3];
			if (voxelZ === z) {
				layerVoxels.push({ x, y, z: voxelZ, c });
			}
		}
		
		// 如果当前层没有体素，跳过
		if (layerVoxels.length === 0) {
			continue;
		}
		
		// 分析当前层每个体素的相邻情况
		for (const voxel of layerVoxels) {
			const connectivity = analyzeVoxelConnectivity(voxel, voxelArray, size);
			const blkId = determineBlockId(connectivity);
			const rotation = determineRotation(connectivity);
			const show = 1
			BLKData.data[`${voxel.x},${voxel.y},${voxel.z}`] = [
				voxel.c, 
				connectivity.adjacentCount, blkId, 
				rotation.x, rotation.y, rotation.z, show, ''
			];
		}
	}
	
	return BLKData;
}

/**
 * 获取BLK数据统计信息
 * @param {Object} blkData - BLK数据对象
 * @returns {Object} 统计信息
 */
export function getBLKDataStats(blkData) {
	const stats = {
		totalVoxels: Object.keys(blkData.data).length,
		blockTypeCounts: {},
		adjacentCounts: {},
		layers: {},
		visibleVoxels: 0,
		hiddenVoxels: 0
	};
	
	for (const [key, voxelData] of Object.entries(blkData.data)) {
		const [c, adjacentCount, blkId, rotX, rotY, rotZ, show] = voxelData;
		const [x, y, z] = key.split(',').map(Number);
		
		// 统计积木类型
		stats.blockTypeCounts[blkId] = (stats.blockTypeCounts[blkId] || 0) + 1;
		
		// 统计相邻数量
		stats.adjacentCounts[adjacentCount] = (stats.adjacentCounts[adjacentCount] || 0) + 1;
		
		// 统计每层体素数量
		stats.layers[z] = (stats.layers[z] || 0) + 1;
		
		// 统计可见性
		if (!show) {
			stats.hiddenVoxels++;
		} else {
			stats.visibleVoxels++;
		}
	}
	
	return stats;
}

/**
 * 分析体素的四面相邻情况（前后左右，按Z轴逐层）
 * @param {Object} voxel - 体素对象 {x, y, z, c}
 * @param {Uint8Array} voxelArray - 体素占用数组
 * @param {Object} size - 体素尺寸
 * @returns {Object} 相邻情况信息
 */
function analyzeVoxelConnectivity(voxel, voxelArray, size) {
	const offsety = size.x;
	const offsetz = size.x * size.y;
	const idx = (x, y, z) => x + y * offsety + z * offsetz;
	
	// 四个方向的偏移：前、后、左、右（在XY平面内，Z轴方向）
	const directions = [
		{ name: 'front', dx: 0, dy: 1, dz: 0 },   // 前（Y轴正方向）
		{ name: 'back', dx: 0, dy: -1, dz: 0 },   // 后（Y轴负方向）
		{ name: 'left', dx: -1, dy: 0, dz: 0 },   // 左（X轴负方向）
		{ name: 'right', dx: 1, dy: 0, dz: 0 }    // 右（X轴正方向）
	];
	
	const adjacent = {
		front: false,
		back: false,
		left: false,
		right: false
	};
	
	let adjacentCount = 0;
	
	// 检查四个方向是否有相邻体素
	for (const dir of directions) {
		const nx = voxel.x + dir.dx;
		const ny = voxel.y + dir.dy;
		const nz = voxel.z + dir.dz; // 保持在当前层
		
		// 检查边界
		if (nx >= 0 && nx < size.x && 
			ny >= 0 && ny < size.y && 
			nz >= 0 && nz < size.z) {
			
			const neighborIndex = idx(nx, ny, nz);
			if (voxelArray[neighborIndex] === 255) {
				adjacent[dir.name] = true;
				adjacentCount++;
			}
		}
	}
	
	return {
		adjacent,
		adjacentCount,
		// 检查是否是对向相邻（前后或左右）
		isOpposite: (adjacent.front && adjacent.back) || (adjacent.left && adjacent.right)
	};
}

/**
 * 根据相邻情况确定积木类型
 * @param {Object} connectivity - 相邻情况信息
 * @returns {string} 积木类型ID
 */
function determineBlockId(connectivity) {
	const { adjacentCount, isOpposite } = connectivity;
	
	switch (adjacentCount) {
		case 0:
			return '0';
		case 1:
			return '1';
		case 2:
			// 如果是对向相邻，保持为'2'，否则为'2L'
			return isOpposite ? '2' : '2L';
		case 3:
			return '3';
		case 4:
			return '4';
		default:
			return '0';
	}
}

/**
 * 根据相邻情况确定旋转角度（90度的整数倍）
 * @param {Object} connectivity - 相邻情况信息
 * @returns {Object} 旋转角度 {x, y, z}
 */
function determineRotation(connectivity) {
	const { adjacent } = connectivity;
	
	// 默认旋转角度
	let rotation = { x: 0, y: 0, z: 0 };
	
	// 根据相邻情况调整旋转（只使用90度的整数倍）
	if (adjacent.front && adjacent.back && adjacent.left && adjacent.right) {
		// 四面相邻，Y轴旋转0度（默认）
		rotation.y = 360;
	} else if (adjacent.front && adjacent.back && adjacent.right) {
		// 前后右相邻，Y轴旋转0度（默认）
		rotation.y = 270;
	} else if (adjacent.front && adjacent.back && adjacent.left) {
		// 前后左相邻，Y轴旋转0度（默认）
		rotation.y = 90;
	} else if (adjacent.back && adjacent.left && adjacent.right) {
		// 后左右相邻，Y轴旋转0度（默认）
		rotation.y = 180;
	} else if (adjacent.front && adjacent.back) {
		// 前后相邻，Y轴旋转0度（默认）
		rotation.y = 90;
	} else if (adjacent.left && adjacent.right) {
		// 左右相邻，Y轴旋转90度
		rotation.y = 0;
	} else if (adjacent.front && adjacent.left) {
		// 前左相邻
		rotation.y = 0;
	} else if (adjacent.front && adjacent.right) {
		// 前右相邻
		rotation.y = 270;
	} else if (adjacent.back && adjacent.left) {
		// 后左相邻
		rotation.y = 90;
	} else if (adjacent.back && adjacent.right) {
		// 后右相邻
		rotation.y = 180;
	} else if (adjacent.front) {
		// 只有前相邻
		rotation.y = 270;
	} else if (adjacent.back) {
		// 只有后相邻
		rotation.y = 90;
	} else if (adjacent.left) {
		// 只有左相邻
		rotation.y = 0;
	} else if (adjacent.right) {
		// 只有右相邻
		rotation.y = 180;
	} else {
		// 没有相邻
		rotation.y = -90;
	}
	
	return rotation;
}
// 重新映射体素颜色
export function refreshPaletteIdx(chunk) {
	if (!chunk || !chunk.data || !chunk.palette) return chunk;
	
	const originalPalette = chunk.palette;
	
	// 第一步：从 chunk.palette 里获取去重的调色板数据
	const colorValueToNewIndex = new Map();
	const newPalette = [0]; // 索引0保留为透明色
	
	// 遍历原始调色板，按颜色值去重
	for (let i = 0; i < originalPalette.length; i++) {
		const colorValue = originalPalette[i] || 0;
		
		// 如果这个颜色值还没有分配新索引
		if (!colorValueToNewIndex.has(colorValue)) {
			const newIndex = newPalette.length;
			colorValueToNewIndex.set(colorValue, newIndex);
			newPalette.push(colorValue);
		}
	}
	
	// 构建旧索引到新索引的映射表
	const oldIndexToNewIndex = new Array(257).fill(0);
	for (let i = 0; i < originalPalette.length; i++) {
		const colorValue = originalPalette[i] || 0;
		oldIndexToNewIndex[i] = colorValueToNewIndex.get(colorValue) || 0;
	}
	
	// 第二步：遍历 chunk.data 重新将颜色索引指向新的调色板
	const remapVoxelColorsLocal = (voxelData, colorIndexMap) => {
		const arr = []
		const newData = new Uint8Array(voxelData.length);
		for (let i = 0; i < voxelData.length; i += 4) {
			newData[i] = voxelData[i];     // x
			newData[i + 1] = voxelData[i + 1]; // y
			newData[i + 2] = voxelData[i + 2]; // z
			newData[i + 3] = colorIndexMap[voxelData[i + 3]] || 0; // 新颜色索引
			if (newData[i + 3] === 0) arr.push([newData[i], newData[i + 1], newData[i + 2]]);
		}
		return newData;
	};
	
	const remappedData = remapVoxelColorsLocal(chunk.data, oldIndexToNewIndex);
	
	return { 
		...chunk, 
		data: remappedData, 
		palette: newPalette 
	};
}
/**
 * 层降噪
 * @param {Object} chunk - The voxel chunk object
 * @param {number} layerDenoiseValue - The layer denoising value (threshold for same-color neighbors)
 * @returns {Object} The denoised chunk
 */
export function layerDenoise(chunk, layerDenoiseValue, maxIterations = 3) {
    if (!chunk || !chunk.data || !chunk.size || !layerDenoiseValue) return chunk;
    layerDenoiseValue = Math.min(layerDenoiseValue, 5);
	
	const data = chunk.data;
	const size = chunk.size;
	const newData = [...data]; // Create a copy to modify

	// 创建3D体素映射 (x,y,z -> voxel info)
	const voxelMap3D = new Map();
	// 分层桶，避免每层重复全量扫描
	const layerBuckets = new Array(size.z);
	for (let li = 0; li < size.z; li++) layerBuckets[li] = [];
	for (let i = 0; i < data.length; i += 4) {
		const x = data[i], y = data[i+1], z = data[i+2], c = data[i+3];
		const key = `${x},${y},${z}`;
		voxelMap3D.set(key, { x, y, z, c, originalIndex: i });
		layerBuckets[z].push({ x, y, z, c, originalIndex: i });
	}

	// 26 个方向在外部定义，避免每个体素重复创建数组
	let directions = [
		// 当前层 (z = 0) - 8个方向
		{ dx: -1, dy: -1, dz: 0 },
		{ dx: 0, dy: -1, dz: 0 },
		{ dx: 1, dy: -1, dz: 0 },
		{ dx: -1, dy: 0, dz: 0 },
		{ dx: 1, dy: 0, dz: 0 },
		{ dx: -1, dy: 1, dz: 0 },
		{ dx: 0, dy: 1, dz: 0 },
		{ dx: 1, dy: 1, dz: 0 },
		// 上一层 (z = -1) - 9个方向（含中心）
		{ dx: 0, dy: 0, dz: -1 },
		{ dx: -1, dy: -1, dz: -1 },
		{ dx: 0, dy: -1, dz: -1 },
		{ dx: 1, dy: -1, dz: -1 },
		{ dx: -1, dy: 0, dz: -1 },
		{ dx: 1, dy: 0, dz: -1 },
		{ dx: -1, dy: 1, dz: -1 },
		{ dx: 0, dy: 1, dz: -1 },
		{ dx: 1, dy: 1, dz: -1 },
		// 下一层 (z = 1) - 9个方向（含中心）
		{ dx: 0, dy: 0, dz: 1 },
		{ dx: -1, dy: -1, dz: 1 },
		{ dx: 0, dy: -1, dz: 1 },
		{ dx: 1, dy: -1, dz: 1 },
		{ dx: -1, dy: 0, dz: 1 },
		{ dx: 1, dy: 0, dz: 1 },
		{ dx: -1, dy: 1, dz: 1 },
		{ dx: 0, dy: 1, dz: 1 },
		{ dx: 1, dy: 1, dz: 1 }
	];

	// 逐层处理 (Z轴方向)
	for (let z = 0; z < size.z; z++) {
		// 使用预先分桶的体素，避免重复扫描
		const layerVoxels = layerBuckets[z];
		
		// 如果当前层没有体素，跳过
		if (layerVoxels.length === 0) continue;
		
		// 迭代处理当前层所有体素，直到没有变化或达到迭代上限
		let iteration = 0;
		while (iteration < maxIterations) {
			let changed = 0;
			const pendingUpdates = new Map(); // key: originalIndex, value: newColor
			// const tmp = {};
			for (const voxel of layerVoxels) {
				const sameColorNeighbors = [];
				const differentColorNeighbors = [];
				
				const voxelColor = newData[voxel.originalIndex + 3];
				
				for (const dir of directions) {
					const neighborX = voxel.x + dir.dx;
					const neighborY = voxel.y + dir.dy;
					const neighborZ = voxel.z + dir.dz;
					
					// 边界检查
					if (neighborX >= 0 && neighborX < size.x && neighborY >= 0 && neighborY < size.y && neighborZ >= 0 && neighborZ < size.z) {
						const neighborKey = `${neighborX},${neighborY},${neighborZ}`;
						const neighbor = voxelMap3D.get(neighborKey);
						if (neighbor) {
							const neighborColor = newData[neighbor.originalIndex + 3];
							if (neighborColor === 0) continue;
							if (neighborColor === voxelColor) sameColorNeighbors.push(neighbor);
							else differentColorNeighbors.push({ idx: neighbor.originalIndex, color: neighborColor });
						}
					}
				}
				
				if (sameColorNeighbors.length <= layerDenoiseValue && differentColorNeighbors.length > 0) {
					// tmp[voxel.x + ',' + voxel.y + ',' + voxel.z] = { voxel, sameColorNeighbors, differentColorNeighbors };
					// 统计不同色邻居颜色频率
					const colorCount = {};
					for (const n of differentColorNeighbors) {
						const keyColor = n.color;
						colorCount[keyColor] = (colorCount[keyColor] || 0) + 1;
					}
					let mostFrequentColor = voxelColor;
					let maxCount = 0;
					for (const k in colorCount) {
						const cnt = colorCount[k];
						if (cnt > maxCount) {
							maxCount = cnt;
							mostFrequentColor = parseInt(k);
						}
					}
					if (mostFrequentColor !== voxelColor) {
						pendingUpdates.set(voxel.originalIndex, mostFrequentColor);
					}
				}
			}
			if (pendingUpdates.size === 0) break;
			// 应用更新
			for (const [origIdx, newColor] of pendingUpdates.entries()) {
				newData[origIdx + 3] = newColor;
				changed++;
			}
			iteration++;
			if (!changed) break;
		}
	}
	
	// 返回降噪后的chunk
	return {
		...chunk,
		data: new Uint8Array(newData)
	};
}

/**
 * 填充模型内部的空腔（增强模型结构强度）
 * 
 * 功能：
 * - 识别并填充模型内部的空腔
 * - 使用泛洪填充算法区分外部和内部空间
 * - 保持外部尺寸不变
 * 
 * 算法：
 * 1. 构建占用数组（标记现有体素）
 * 2. 从边界开始泛洪填充，标记外部空间
 * 3. 未标记为外部的空腔即为内部空间
 * 4. 将内部空间填充为体素（使用相邻体素的颜色）
 * 
 * @param {Object} chunk - VOX 数据对象
 *                          - data: Uint8Array 体素数据数组 (x, y, z, colorIndex)
 *                          - size: {x, y, z} 模型尺寸
 * @returns {Object} 填充后的 VOX 数据对象
 */
export function fillInnerVoxels(chunk) {
	try {
		if (!chunk || !chunk.data || !chunk.size) return chunk
		const data = chunk.data
		const size = chunk.size
		const sx = size.x
		const sy = size.y
		const sz = size.z
		if (sx <= 0 || sy <= 0 || sz <= 0) return chunk

		const offsety = sx
		const offsetz = sx * sy
		const idx = (x, y, z) => x + y * offsety + z * offsetz

		// 1. 构建占用数组和颜色数组
		const occ = new Uint8Array(sx * sy * sz) // 占用：1表示有体素，0表示空
		const colorAt = new Uint16Array(sx * sy * sz) // 存储体素颜色索引
		
		// 将体素数据转换为对象数组格式
		const voxels = []
		for (let i = 0; i < data.length; i += 4) {
			const x = data[i]
			const y = data[i + 1]
			const z = data[i + 2]
			const c = data[i + 3]
			if (x < 0 || x >= sx || y < 0 || y >= sy || z < 0 || z >= sz) continue
			const id = idx(x, y, z)
			occ[id] = 1
			colorAt[id] = c || 0 // 存储原始颜色索引
			voxels.push({ x, y, z, i: c || 0 })
		}

		// 2. 泛洪填充外部空气，标记为 ext
		const ext = new Uint8Array(sx * sy * sz) // 外部空气：1表示外部，0表示内部或占用
		const qx = new Int32Array(sx * sy * sz)
		const qy = new Int32Array(sx * sy * sz)
		const qz = new Int32Array(sx * sy * sz)
		let qh = 0
		let qt = 0
		
		const enqueueExt = (x, y, z) => {
			if (x < 0 || x >= sx || y < 0 || y >= sy || z < 0 || z >= sz) return
			const id = idx(x, y, z)
			if (ext[id] || occ[id]) return // 已经访问过或被体素占用
			ext[id] = 1
			qx[qt] = x
			qy[qt] = y
			qz[qt] = z
			qt++
		}
		
		// 从边界开始泛洪
		for (let x = 0; x < sx; x++) {
			for (let y = 0; y < sy; y++) {
				enqueueExt(x, y, 0)
				enqueueExt(x, y, sz - 1)
			}
		}
		for (let x = 0; x < sx; x++) {
			for (let z = 0; z < sz; z++) {
				enqueueExt(x, 0, z)
				enqueueExt(x, sy - 1, z)
			}
		}
		for (let y = 0; y < sy; y++) {
			for (let z = 0; z < sz; z++) {
				enqueueExt(0, y, z)
				enqueueExt(sx - 1, y, z)
			}
		}
		
		const dirs6 = [[1, 0, 0], [-1, 0, 0], [0, 1, 0], [0, -1, 0], [0, 0, 1], [0, 0, -1]] // 6邻接方向
		while (qh < qt) {
			const cx = qx[qh]
			const cy = qy[qh]
			const cz = qz[qh]
			qh++
			for (const [dx, dy, dz] of dirs6) {
				const nx = cx + dx
				const ny = cy + dy
				const nz = cz + dz
				if (nx < 0 || nx >= sx || ny < 0 || ny >= sy || nz < 0 || nz >= sz) continue
				const idn = idx(nx, ny, nz)
				if (ext[idn] || occ[idn]) continue
				ext[idn] = 1
				qx[qt] = nx
				qy[qt] = ny
				qz[qt] = nz
				qt++
			}
		}

		// 3. 识别内部空腔单元 (interior = !occ && !ext)
		const interior = new Uint8Array(sx * sy * sz)
		for (let z = 0; z < sz; z++) {
			for (let y = 0; y < sy; y++) {
				for (let x = 0; x < sx; x++) {
					const id = idx(x, y, z)
					interior[id] = (occ[id] === 0 && ext[id] === 0) ? 1 : 0
				}
			}
		}

		// 4. 使用BFS从外壳向内填充内部空腔，颜色从最近的邻居获取
		const newVoxels = [...voxels] // 复制现有体素
		const addedSet = new Set() // 记录已添加的体素位置，避免重复
		const fillQueue = [] // BFS队列：{x, y, z, i: color}
		
		// 初始化队列：所有与外壳体素相邻的内部空腔单元
		for (let i = 0; i < voxels.length; i++) {
			const v = voxels[i]
			for (const [dx, dy, dz] of dirs6) {
				const nx = v.x + dx
				const ny = v.y + dy
				const nz = v.z + dz
				if (nx < 0 || nx >= sx || ny < 0 || ny >= sy || nz < 0 || nz >= sz) continue
				const nid = idx(nx, ny, nz)
				// 如果是内部空腔且未被占用，则作为种子
				if (interior[nid] && occ[nid] === 0) {
					const key = `${nx},${ny},${nz}`
					if (!addedSet.has(key)) {
						fillQueue.push({ x: nx, y: ny, z: nz, i: v.i || 0 }) // 使用相邻体素颜色
						addedSet.add(key)
					}
				}
			}
		}

		// BFS填充所有内部空腔
		let head = 0
		while (head < fillQueue.length) {
			const { x, y, z, i: color } = fillQueue[head++]
			const id = idx(x, y, z)
			
			// 标记为已占用
			occ[id] = 1
			colorAt[id] = color
			newVoxels.push({ x, y, z, i: color })
			
			// 继续向内部扩展
			for (const [dx, dy, dz] of dirs6) {
				const nx = x + dx
				const ny = y + dy
				const nz = z + dz
				if (nx < 0 || nx >= sx || ny < 0 || ny >= sy || nz < 0 || nz >= sz) continue
				const nid = idx(nx, ny, nz)
				const key = `${nx},${ny},${nz}`
				// 如果是内部空腔且未被添加过
				if (interior[nid] && occ[nid] === 0 && !addedSet.has(key)) {
					// 查找最近的已占用邻居的颜色（优先使用直接相邻的颜色）
					let neighborColor = color // 默认使用当前颜色
					for (const [ndx, ndy, ndz] of dirs6) {
						const nnx = nx + ndx
						const nny = ny + ndy
						const nnz = nz + ndz
						if (nnx < 0 || nnx >= sx || nny < 0 || nny >= sy || nnz < 0 || nnz >= sz) continue
						const nnid = idx(nnx, nny, nnz)
						if (occ[nnid] === 1) {
							neighborColor = colorAt[nnid]
							break // 找到第一个邻居就使用
						}
					}
					fillQueue.push({ x: nx, y: ny, z: nz, i: neighborColor })
					addedSet.add(key)
				}
			}
		}

		// 5. 将新体素数组转换回 Uint8Array 格式
		const newData = new Uint8Array(newVoxels.length * 4)
		for (let i = 0; i < newVoxels.length; i++) {
			const v = newVoxels[i]
			newData[i * 4] = v.x
			newData[i * 4 + 1] = v.y
			newData[i * 4 + 2] = v.z
			newData[i * 4 + 3] = v.i || 0
		}

		return {
			...chunk,
			data: newData
		}
	} catch (e) {
		console.error('fillInnerVoxels error:', e)
		return chunk
	}
}

/**
 * Delete surrounding blank voxels (trim voxels)
 * @param {Object} chunk - The voxel chunk object
 * @returns {Object} The trimmed chunk
 */
export function trimVoxels(chunk) {
	let minX = 255, maxX = 0, minY = 255, maxY = 0, minZ = 255, maxZ = 0;
	const data = chunk.data;
	for (let i = 0; i < data.length; i += 4) {
		const x = data[i], y = data[i+1], z = data[i+2];
		if (x < minX) minX = x; if (x > maxX) maxX = x;
		if (y < minY) minY = y; if (y > maxY) maxY = y;
		if (z < minZ) minZ = z; if (z > maxZ) maxZ = z;
	}

	const newVoxels = [];
	for (let i = 0; i < data.length; i += 4) {
		const x = data[i], y = data[i+1], z = data[i+2], c = data[i+3];
		if (x >= minX && x <= maxX && y >= minY && y <= maxY && z >= minZ && z <= maxZ) {
			newVoxels.push(x - minX, y - minY, z - minZ, c);
		}
	}

	chunk.size = {
		x: maxX - minX + 1,
		y: maxY - minY + 1,
		z: maxZ - minZ + 1
	};
	chunk.data = new Uint8Array(newVoxels);
	return chunk;
}

/**
 * Keep only voxel shell (extract shell)
 * @param {Object} chunk - The voxel chunk object
 * @returns {Object} The shell-extracted chunk
 */
export function getShellVoxels(chunk) {
	const data = chunk.data;
	const size = chunk.size;
	if (!data || !size || !size.x || !size.y || !size.z) {
		return chunk;
	}
	const offsety = size.x;
	const offsetz = size.x * size.y;
	const array = new Uint8Array(size.x * size.y * size.z);
	
	for (let i = 0; i < data.length; i += 4) {
		const x = data[i], y = data[i+1], z = data[i+2];
		const index = x + y * offsety + z * offsetz;
		array[index] = 255;
	}
	
	const shellVoxels = [];
	for (let i = 0; i < data.length; i += 4) {
		const x = data[i], y = data[i+1], z = data[i+2], c = data[i+3];
		if (isSurfaceVoxel(x, y, z, array, size)) {
			shellVoxels.push(x, y, z, c);
		}
	}
	chunk.data = new Uint8Array(shellVoxels);
	return chunk;
}

// 计算内部体素
export function calcInternalVoxels(chunk) {
	// 计算并返回模型“内部体素”集合：
	// 1) 非表面的实体体素（实心内部）
	// 2) 被外壳包围、与外部不连通的空单元（空腔内部，颜色占位为0）
	const data = chunk.data;
	const size = chunk.size;

	const offsety = size.x;
	const offsetz = size.x * size.y;
	const idx = (x, y, z) => x + y * offsety + z * offsetz;

	// 占用数组：255 表示有体素，0 表示空
	const array = new Uint8Array(size.x * size.y * size.z);
	for (let i = 0; i < data.length; i += 4) {
		const x = data[i], y = data[i+1], z = data[i+2];
		array[idx(x, y, z)] = 255;
	}

	// 使用紧凑型颜色数组：存储 colorIndex+1；0 表示非内部
	const colors = new Uint16Array(size.x * size.y * size.z);

	// 1) 收集非表面实体体素（实心内部）
	for (let i = 0; i < data.length; i += 4) {
		const x = data[i], y = data[i+1], z = data[i+2], c = data[i+3];
		if (!isSurfaceVoxel(x, y, z, array, size)) {
			colors[idx(x, y, z)] = (c + 1);
		}
	}

	// 2) 通过边界泛洪，标记外部空域，剩余空单元即为空腔内部
	const sx = size.x, sy = size.y, sz = size.z;
	const visited = new Uint8Array(sx * sy * sz);
	// 使用基于头指针的队列，避免 shift() 造成 O(n)
	const qx = new Int32Array(sx * sy * sz);
	const qy = new Int32Array(sx * sy * sz);
	const qz = new Int32Array(sx * sy * sz);
	let qh = 0, qt = 0;
	const enqueue = (xx, yy, zz) => {
		if (xx < 0 || xx >= sx || yy < 0 || yy >= sy || zz < 0 || zz >= sz) return;
		const id = idx(xx, yy, zz);
		if (visited[id]) return;
		if (array[id] !== 0) return; // 非空（有体素）不入队
		visited[id] = 1;
		qx[qt] = xx; qy[qt] = yy; qz[qt] = zz; qt++;
	};
	// 六个面的边界空单元入队
	for (let x = 0; x < sx; x++) {
		for (let y = 0; y < sy; y++) {
			enqueue(x, y, 0);
			enqueue(x, y, sz - 1);
		}
	}
	for (let x = 0; x < sx; x++) {
		for (let z = 0; z < sz; z++) {
			enqueue(x, 0, z);
			enqueue(x, sy - 1, z);
		}
	}
	for (let y = 0; y < sy; y++) {
		for (let z = 0; z < sz; z++) {
			enqueue(0, y, z);
			enqueue(sx - 1, y, z);
		}
	}
	const dirs = [[1,0,0],[-1,0,0],[0,1,0],[0,-1,0],[0,0,1],[0,0,-1]];
	while (qh < qt) {
		const cx = qx[qh], cy = qy[qh], cz = qz[qh]; qh++;
		for (const [dx, dy, dz] of dirs) {
			const nx = cx + dx, ny = cy + dy, nz = cz + dz;
			if (nx < 0 || nx >= sx || ny < 0 || ny >= sy || nz < 0 || nz >= sz) continue;
			const idn = idx(nx, ny, nz);
			if (visited[idn]) continue;
			if (array[idn] !== 0) continue; // 体素阻挡
			visited[idn] = 1;
			qx[qt] = nx; qy[qt] = ny; qz[qt] = nz; qt++;
		}
	}
	// 未访问到且为空的位置即为空腔内部，颜色占位 0
	for (let z = 0; z < sz; z++) {
		for (let y = 0; y < sy; y++) {
			for (let x = 0; x < sx; x++) {
				const id = idx(x, y, z);
				if (array[id] === 0 && visited[id] === 0) {
					colors[id] = 0 + 1; // cavity with colorIndex 0 stored as 1
				}
			}
		}
	}

	return { colors, size };
}

/**
 * Determine if a voxel is a surface voxel
 * @param {number} x - X coordinate
 * @param {number} y - Y coordinate
 * @param {number} z - Z coordinate
 * @param {Uint8Array} array - Voxel occupancy array
 * @param {Object} size - Chunk size object
 * @returns {boolean} True if surface voxel
 */
export function isSurfaceVoxel(x, y, z, array, size) {
	const offsety = size.x;
	const offsetz = size.x * size.y;
	const idx = (x, y, z) => x + y * offsety + z * offsetz;
	
	const dirs = [
		[1,0,0], [-1,0,0],
		[0,1,0], [0,-1,0],
		[0,0,1], [0,0,-1]
	];
	
	for (const [dx, dy, dz] of dirs) {
		const nx = x + dx, ny = y + dy, nz = z + dz;
		
		if (
			nx < 0 || nx >= size.x ||
			ny < 0 || ny >= size.y ||
			nz < 0 || nz >= size.z
		) {
			return true;
		}
		
		if (array[idx(nx, ny, nz)] === 0) {
			return true;
		}
	}
	
	return false;
}

// 计算体素颜色表
export function calcVoxelColors(sceneIdx = 0, voxelChunks) {
    // 检查 voxelChunks 是否存在
    if (!voxelChunks || !Array.isArray(voxelChunks)) {
      return {}
    }
    const voxelChunk = voxelChunks[sceneIdx]
    if (!voxelChunk || !voxelChunk.data || !voxelChunk.palette) {
      return {}
    }
    const data = voxelChunk.data
    const palette = voxelChunk.palette
    const colorCount = {}
    // 遍历所有体素数据，统计颜色使用次数
    for (let i = 0; i < data.length; i += 4) {
      // const x = data[i]
      // const y = data[i + 1]
      // const z = data[i + 2]
      const colorIndex = data[i + 3]
      // 跳过透明体素 (colorIndex = 0)
      if (colorIndex === 0) continue
      // 从调色板获取颜色值 getVoxelHexColor(chunk.palette[i])
      const paletteColor = palette[colorIndex]
      if (!paletteColor || paletteColor === undefined) continue
      const hexColor = getVoxelHexColor(paletteColor)
      // 统计颜色使用次数
      colorCount[hexColor] = (colorCount[hexColor] || 0) + 1
    }
    return colorCount
}
/**
 * Add help voxels layer by layer along Z-axis
 * @param {Object} chunk - The voxel chunk object
 * @returns {Object} The chunk with help voxels added
 */
export function addHelpVoxels(chunk) {
	// 获取内部体素，同步全局缓存，保持与既有调用兼容
	internalVoxels = calcInternalVoxels(chunk);
	const data = chunk.data;
	const size = chunk.size;
	
	const offsety = size.x;
	const offsetz = size.x * size.y;
	const array = new Uint8Array(size.x * size.y * size.z);
	const indexColor = new Uint16Array(size.x * size.y * size.z);
	
	for (let i = 0; i < data.length; i += 4) {
		const x = data[i], y = data[i+1], z = data[i+2];
		const index = x + y * offsety + z * offsetz;
		array[index] = 255;
		indexColor[index] = data[i+3] + 1;
	}
	
	const allVoxels = [...data];
	const added = new Set();
	
	for (let z = 1; z < size.z - 1; z++) {
		const layerVoxels = [];
		
		for (let i = 0; i < data.length; i += 4) {
			const x = data[i], y = data[i+1], voxelZ = data[i+2], c = data[i+3];
			if (voxelZ === z) {
				layerVoxels.push({ x, y, z: voxelZ, c });
			}
		}
		
		const helpVoxels = addHelpVoxelsForLayer(layerVoxels, array, size, z, added, indexColor);
		allVoxels.push(...helpVoxels);
		
		for (const voxel of helpVoxels) {
			const index = voxel.x + voxel.y * offsety + voxel.z * offsetz;
			array[index] = 255;
		}
	}
	
	chunk.data = new Uint8Array(allVoxels);
	return chunk;
}

/**
 * Add help voxels for a single layer
 * @param {Array} layerVoxels - Voxels in the current layer
 * @param {Uint8Array} array - Voxel occupancy array
 * @param {Object} size - Chunk size object
 * @param {number} layerZ - Current layer Z coordinate
 * @param {Set} added - Set of already added voxel positions
 * @returns {Array} Array of help voxel data
 */
function addHelpVoxelsForLayer(layerVoxels, array, size, layerZ, added, indexColor) {
	const helpVoxels = [];
	for (const voxel of layerVoxels) {
		const diagonalVoxels = findDiagonalVoxels(voxel, layerVoxels);
		for (const diagonalVoxel of diagonalVoxels) {
			const cornerPositions = findCornerPositions(voxel, diagonalVoxel);
			
			if (areBothCornersEmpty(cornerPositions, array, size)) {
				for (const cornerPos of cornerPositions) {
					const id = cornerPos.x + cornerPos.y * size.x + cornerPos.z * size.x * size.y;
					if (!added.has(id)) {
						if (isInternalPosition(cornerPos.x, cornerPos.y, cornerPos.z)) {
							// 优先使用相邻外壳体素颜色
							let color = getAdjacentShellColor(cornerPos.x, cornerPos.y, cornerPos.z, array, size, indexColor);
							if (color < 0) {
								// 回退到内部体素颜色或当前体素颜色
								const colorVal = internalVoxels.colors[id];
								color = colorVal > 0 ? (colorVal - 1) : voxel.c;
							}
							helpVoxels.push(cornerPos.x, cornerPos.y, cornerPos.z, color);
							added.add(id);
						}
					}
				}
			}
		}
	}
	
	return helpVoxels;
}

// 获取与位置相邻的体素颜色（colorIndex），未找到返回 -1
function getAdjacentShellColor(x, y, z, array, size, indexColor) {
	const offsety = size.x;
	const offsetz = size.x * size.y;
	const idx = (xx, yy, zz) => xx + yy * offsety + zz * offsetz;
	const dirs = [[1,0,0],[-1,0,0],[0,1,0],[0,-1,0],[0,0,1],[0,0,-1]];
	for (const [dx, dy, dz] of dirs) {
		const nx = x + dx, ny = y + dy, nz = z + dz;
		if (nx < 0 || nx >= size.x || ny < 0 || ny >= size.y || nz < 0 || nz >= size.z) continue;
		const nid = idx(nx, ny, nz);
		if (array[nid] !== 0) {
			const c = indexColor[nid];
			if (c > 0) return c - 1;
			// 仅取外壳体素
			// if (isSurfaceVoxel(nx, ny, nz, array, size)) {
			// 	const c = indexColor[nid];
			// 	if (c > 0) return c - 1;
			// }
		}
	}
	return -1;
}

/**
 * Check if both corner positions are empty
 * @param {Array} cornerPositions - Array of corner positions
 * @param {Uint8Array} array - Voxel occupancy array
 * @param {Object} size - Chunk size object
 * @returns {boolean} True if both corners are empty
 */
function areBothCornersEmpty(cornerPositions, array, size) {
	const offsety = size.x;
	const offsetz = size.x * size.y;
	const idx = (x, y, z) => x + y * offsety + z * offsetz;
	
	for (const cornerPos of cornerPositions) {
		const x = cornerPos.x, y = cornerPos.y, z = cornerPos.z;
		
		if (
			x < 0 || x >= size.x ||
			y < 0 || y >= size.y ||
			z < 0 || z >= size.z
		) {
			return false;
		}
		
		if (array[idx(x, y, z)] !== 0) {
			return false;
		}
	}
	
	return true;
}

/**
 * Find diagonal voxels for a given voxel
 * @param {Object} voxel - The reference voxel
 * @param {Array} layerVoxels - All voxels in the layer
 * @returns {Array} Array of diagonal voxels
 */
function findDiagonalVoxels(voxel, layerVoxels) {
	const diagonalVoxels = [];
	const diagonalDirs = [[1,1], [1,-1], [-1,1], [-1,-1]];
	for (const [dx, dy] of diagonalDirs) {
		const nx = voxel.x + dx, ny = voxel.y + dy;
		
		for (const other of layerVoxels) {
			if (other.x === nx && other.y === ny) {
				diagonalVoxels.push(other);
				break;
			}
		}
	}
	
	return diagonalVoxels;
}

/**
 * Calculate corner positions between two voxels
 * @param {Object} voxel1 - First voxel
 * @param {Object} voxel2 - Second voxel
 * @returns {Array} Array of corner positions
 */
function findCornerPositions(voxel1, voxel2) {
	const cornerPositions = [];
	const dx = voxel2.x - voxel1.x;
	const dy = voxel2.y - voxel1.y;
	
	if (dx !== 0 && dy !== 0) {
		const corner1 = {
			x: voxel1.x + dx,
			y: voxel1.y,
			z: voxel1.z
		};
		const corner2 = {
			x: voxel1.x,
			y: voxel1.y + dy,
			z: voxel1.z
		};
		
		cornerPositions.push(corner1, corner2);
	}
	
	return cornerPositions;
}

/**
 * Check if a position is an internal voxel
 * @param {number} x - X coordinate
 * @param {number} y - Y coordinate
 * @param {number} z - Z coordinate
 * @returns {boolean} True if internal voxel
 */
function isInternalPosition(x, y, z) {
	if (!internalVoxels || !internalVoxels.colors) return false;
	const size = internalVoxels.size;
	if (x < 0 || x >= size.x || y < 0 || y >= size.y || z < 0 || z >= size.z) return false;
	const id = x + y * size.x + z * size.x * size.y;
	return internalVoxels.colors[id] > 0;
}

/**
 * Get the internal voxels object (for external access)
 * @returns {Object} The internal voxels object
 */
export function getInternalVoxels() {
	return internalVoxels;
}

/**
 * Reset the internal voxels object
 */
export function resetInternalVoxels() {
	internalVoxels = { colors: null, size: { x: 0, y: 0, z: 0 } };
} 
/**
 * 优化体素积木数据 - 进行颗粒合并
 * @param {Object} blockData - BLOCK数据对象
 * @returns {Object} 优化后的BLOCK数据
 */
export function optimizeBLOCKData(blockData) {
	// 深拷贝BLK数据以避免修改原始数据
	const optimizedData = JSON.parse(JSON.stringify(blockData));
	
	// 按Z轴逐层处理
	for (let z = 0; z < optimizedData.size.z; z++) {
		//合并相邻的颗粒（blkId为'X2'）
		processBlockLayerOptimization(optimizedData, z);
	}
	
	return optimizedData;
}
/**
 * 优化串联数据 - 进行颗粒合并
 * @param {Object} chainData - CHAIN数据对象
 * @returns {Object} 优化后的CHAIN数据
 */
export function optimizeCHAINData(chainData, optimize = 1) {
	// 深拷贝BLK数据以避免修改原始数据
	const optimizedData = JSON.parse(JSON.stringify(chainData));
	// 按Z轴逐层处理
	for (let z = 0; z < optimizedData.size.z; z++) {
		if (optimize > 2) {
			//合并相邻的颗粒（blkId为'4X4'）
			processChainLayerOptimization4(optimizedData, z, '4', '4X4');
		}
		if (optimize > 1) {
			//合并相邻的颗粒（blkId为'4X3'）
			processChainLayerOptimization3(optimizedData, z, '4', '4X3');
		}
		//合并相邻的颗粒（blkId为'4X'）
		processChainLayerOptimization2(optimizedData, z, '4', '4X');
	}
	return optimizedData;
}
/**
 * 优化BLK数据 - 处理对侧相邻、三侧相邻和四侧相邻的颗粒
 * @param {Object} blkData - BLK数据对象
 * @returns {Object} 优化后的BLK数据
 */
export function optimizeBLKData(blkData) {
	// 深拷贝BLK数据以避免修改原始数据
	const optimizedData = JSON.parse(JSON.stringify(blkData));
	
	// 按Z轴逐层处理
	for (let z = 0; z < optimizedData.size.z; z++) {
		// 1. 处理对侧相邻的颗粒（blkId为'2'）
		processLayerOptimization(optimizedData, z, '2', '2X');
		
		// 2. 处理三侧相邻的颗粒（blkId为'3'）
		processLayerOptimization(optimizedData, z, '3', '3X');
		
		// 3. 处理四侧相邻的颗粒（blkId为'4'）
		processLayerOptimization(optimizedData, z, '4', '4X');
	}
	
	return optimizedData;
}

/**
 * 处理单层的优化
 * @param {Object} blkData - BLK数据对象
 * @param {number} layerZ - 当前层Z坐标
 * @param {string} targetBlkId - 目标积木类型ID
 * @param {string} newBlkId - 新的积木类型ID
 */
function processLayerOptimization(blkData, layerZ, targetBlkId, newBlkId) {
	// 收集当前层指定blkId的同色颗粒
	const layerVoxels = collectLayerVoxelsByBlkId(blkData, layerZ, targetBlkId);
	// 按颜色分组
	const colorGroups = groupVoxelsByColor(layerVoxels);
	
	// 全局跟踪已处理的颗粒（在整个层处理过程中共享）
	const globalProcessedVoxels = new Set();
	
	// 处理每个颜色组
	for (const [color, voxels] of Object.entries(colorGroups)) {
		// 按Y轴逐行处理
		processRowsOptimization(blkData, voxels, newBlkId, targetBlkId, globalProcessedVoxels, layerZ);
		
		// 按X轴逐列处理
		processColumnsOptimization(blkData, voxels, newBlkId, targetBlkId, globalProcessedVoxels, layerZ);
	}
}

/**
 * 收集指定层的指定blkId的体素
 * @param {Object} blkData - BLK数据对象
 * @param {number} layerZ - 层Z坐标
 * @param {string} targetBlkId - 目标积木类型ID
 * @returns {Array} 体素数组
 */
function collectLayerVoxelsByBlkId(blkData, layerZ, targetBlkId) {
	const layerVoxels = [];
	
	for (const [key, voxelData] of Object.entries(blkData.data)) {
		const [x, y, z] = key.split(',').map(Number);
		const [c, adjacentCount, blkId, rotX, rotY, rotZ, show, direction] = voxelData;
		if (z === layerZ && blkId === targetBlkId && show) {
			layerVoxels.push({ x, y, z, c, adjacentCount, blkId, rotX, rotY, rotZ, show, direction });
		}
	}
	
	return layerVoxels;
}
function getBlkVox(x, y, z, voxelData) {
	if (!voxelData) return null;
	const [c, adjacentCount, blkId, rotX, rotY, rotZ, show, direction] = voxelData;
	return { x, y, z, c, adjacentCount, blkId, rotX, rotY, rotZ, show, direction };
}
/**
 * 按颜色分组体素
 * @param {Array} voxels - 体素数组
 * @returns {Object} 按颜色分组的体素
 */
function groupVoxelsByColor(voxels) {
	const colorGroups = {};
	
	for (const voxel of voxels) {
		const color = voxel.c;
		if (!colorGroups[color]) {
			colorGroups[color] = [];
		}
		colorGroups[color].push(voxel);
	}
	
	return colorGroups;
}

/**
 * 按Y轴逐行处理优化
 * @param {Object} blkData - BLK数据对象
 * @param {Array} voxels - 体素数组
 * @param {string} newBlkId - 新的积木类型ID
 * @param {string} targetBlkId - 目标积木类型ID
 * @param {Set} globalProcessedVoxels - 全局已处理颗粒集合
 */
function processRowsOptimization(blkData, voxels, newBlkId, targetBlkId, globalProcessedVoxels, layerZ) {
    // 按Y坐标分组
    const rowGroups = {};
    for (const voxel of voxels) {
        const y = voxel.y;
        if (!rowGroups[y]) {
            rowGroups[y] = [];
        }
        rowGroups[y].push(voxel);
    }
    // 处理每行
    for (const [yStr, rowVoxels] of Object.entries(rowGroups)) {
        const y = Number(yStr);
        if (rowVoxels.length >= 2) {
            // 构建x查找表
            const minX = Math.min(...rowVoxels.map(v => v.x));
            const maxX = Math.max(...rowVoxels.map(v => v.x));
            // 错位起始x
            let startX = minX;
			// 在百乐酷颗粒暂时不用以下错位合并算法
            // if (layerZ % 2 === 1) {
            //     startX = (y % 2 === 0) ? minX : minX + 1;
            // } else {
            //     startX = (y % 2 === 1) ? minX : minX + 1;
            // }
            for (let x = startX; x <= maxX; x += 2) {
                const k1 = `${x},${y},${layerZ}`;
                const k2 = `${x+1},${y},${layerZ}`;
                const vox1 = rowVoxels.find(v => v.x === x);
                const vox2 = rowVoxels.find(v => v.x === x + 1);
				
                if (!vox1 || !vox2) continue;
                if (globalProcessedVoxels.has(k1) || globalProcessedVoxels.has(k2)) continue;
                const d1 = blkData.data[k1];
                const d2 = blkData.data[k2];
                // 检查方向一致
				const blkVox1 = getBlkVox(x, y, layerZ, d1);
				const blkVox2 = getBlkVox(x + 1, y, layerZ, d2);
                const isDirectionConsistent = checkDirectionConsistency(blkData, blkVox1, blkVox2, targetBlkId);
                if (isDirectionConsistent) {
                    d1[2] = newBlkId;
                    d1[7] = 'X';
                    d2[6] = 0;
                    globalProcessedVoxels.add(k1);
                    globalProcessedVoxels.add(k2);
                }
            }
        }
    }
}

/**
 * 按X轴逐列处理优化
 * @param {Object} blkData - BLK数据对象
 * @param {Array} voxels - 体素数组
 * @param {string} newBlkId - 新的积木类型ID
 * @param {string} targetBlkId - 目标积木类型ID
 * @param {Set} globalProcessedVoxels - 全局已处理颗粒集合
 */
function processColumnsOptimization(blkData, voxels, newBlkId, targetBlkId, globalProcessedVoxels, layerZ) {
    // 按X坐标分组
    const columnGroups = {};
    for (const voxel of voxels) {
        const x = voxel.x;
        if (!columnGroups[x]) {
            columnGroups[x] = [];
        }
        columnGroups[x].push(voxel);
    }
    // 处理每列
    for (const [xStr, columnVoxels] of Object.entries(columnGroups)) {
        const x = Number(xStr);
        if (columnVoxels.length >= 2) {
            // 构建y查找表
            const minY = Math.min(...columnVoxels.map(v => v.y));
            const maxY = Math.max(...columnVoxels.map(v => v.y));
            // 错位起始y
            let startY = minY;
			// 在百乐酷颗粒暂时不用以下错位合并算法
            // if (layerZ % 2 === 1) {
            //     startY = (x % 2 === 0) ? minY + 1 : minY;
            // } else {
            //     startY = (x % 2 === 1) ? minY + 1 : minY;
            // }
            for (let y = startY; y <= maxY; y += 2) {
                const k1 = `${x},${y},${layerZ}`;
                const k2 = `${x},${y+1},${layerZ}`;
                const vox1 = columnVoxels.find(v => v.y === y);
                const vox2 = columnVoxels.find(v => v.y === y + 1);
                if (!vox1 || !vox2) continue;
                if (globalProcessedVoxels.has(k1) || globalProcessedVoxels.has(k2)) continue;
                const d1 = blkData.data[k1];
                const d2 = blkData.data[k2];
                // 检查方向一致
				const blkVox1 = getBlkVox(x, y, layerZ, d1);
				const blkVox2 = getBlkVox(x, y + 1, layerZ, d2);
                const isDirectionConsistent = checkDirectionConsistency(blkData, blkVox1, blkVox2, targetBlkId);
                if (isDirectionConsistent) {
                    d1[2] = newBlkId;
                    d1[7] = 'Y';
                    d2[6] = 0;
                    globalProcessedVoxels.add(k1);
                    globalProcessedVoxels.add(k2);
                }
            }
        }
    }
}

/**
 * 检查两个体素是否是对侧相邻
 * @param {Object} blkData - BLK数据对象
 * @param {Object} voxel1 - 第一个体素
 * @param {Object} voxel2 - 第二个体素
 * @returns {boolean} 是否是对侧相邻
 */
function checkOppositeAdjacent(blkData, voxel1, voxel2) {
	// 检查两个体素是否都是blkId为'2'的颗粒
	const key1 = `${voxel1.x},${voxel1.y},${voxel1.z}`;
	const key2 = `${voxel2.x},${voxel2.y},${voxel2.z}`;
	
	const data1 = blkData.data[key1];
	const data2 = blkData.data[key2];
	
	if (!data1 || !data2) {
		return false;
	}
	
	const blkId1 = data1[2];
	const blkId2 = data2[2];
	
	// 两个体素都必须是blkId为'2'的颗粒
	if (blkId1 !== '2' || blkId2 !== '2') {
		return false;
	}
	// 检查是否是对侧相邻（前后或左右）
	// 由于我们是在同一行或同一列中检查，所以这里主要是检查它们是否都是对侧相邻的颗粒
	// 在BLK数据中，blkId为'2'表示对侧相邻，'2L'表示非对侧相邻
	return true; // 如果两个都是blkId为'2'，那么它们都是对侧相邻的
}

/**
 * 检查两个相邻颗粒的方向是否一致
 * @param {Object} blkData - BLK数据对象
 * @param {Object} voxel1 - 第一个体素
 * @param {Object} voxel2 - 第二个体素
 * @param {string} targetBlkId - 目标积木类型ID
 * @param {string} direction - 检查方向 ('horizontal' 或 'vertical')
 * @returns {boolean} 方向是否一致
 */
function checkDirectionConsistency(blkData, voxel1, voxel2, targetBlkId) {
	const key1 = `${voxel1.x},${voxel1.y},${voxel1.z}`;
	const key2 = `${voxel2.x},${voxel2.y},${voxel2.z}`;
	const data1 = blkData.data[key1];
	const data2 = blkData.data[key2];
	
	if (!data1 || !data2) {
		return false;
	}
	
	const blkId1 = data1[2];
	const blkId2 = data2[2];
	
	// 两个体素都必须是目标blkId的颗粒
	if (blkId1 !== targetBlkId || blkId2 !== targetBlkId) {
		return false;
	}
	
	// 根据目标blkId和检查方向判断方向一致性
	if (targetBlkId === '2') {
		// 对于blkId为'2'的颗粒（对侧相邻），需要检查是否都是对侧相邻
		return checkOppositeAdjacent(blkData, voxel1, voxel2);
	} else if (targetBlkId === '3') {
		// 对于blkId为'3'的颗粒（三侧相邻），需要检查相邻的面是否一致
		return checkThreeSideConsistency(blkData, voxel1, voxel2);
	} else if (targetBlkId === '4') {
		// 对于blkId为'4'的颗粒（四侧相邻），需要检查相邻的面是否一致
		return checkFourSideConsistency(blkData, voxel1, voxel2);
	}
	
	return false;
}

/**
 * 检查三侧相邻颗粒的一致性
 * @param {Object} blkData - BLK数据对象
 * @param {Object} voxel1 - 第一个体素
 * @param {Object} voxel2 - 第二个体素
 * @returns {boolean} 是否一致
 */
function checkThreeSideConsistency(blkData, voxel1, voxel2) {
	// 获取两个体素的相邻信息
	const adjacent1 = getVoxelAdjacentInfo(blkData, voxel1);
	const adjacent2 = getVoxelAdjacentInfo(blkData, voxel2);
	
	if (!adjacent1 || !adjacent2) {
		return false;
	}
	
	// 检查两个体素是否都有三侧相邻
	if (adjacent1.adjacentCount !== 3 || adjacent2.adjacentCount !== 3) {
		return false;
	}

	return (!adjacent1.adjacent.front && adjacent1.adjacent.front === adjacent2.adjacent.front) ||
		   (!adjacent1.adjacent.back && adjacent1.adjacent.back === adjacent2.adjacent.back) ||
		   (!adjacent1.adjacent.left && adjacent1.adjacent.left === adjacent2.adjacent.left) ||
		   (!adjacent1.adjacent.right && adjacent1.adjacent.right === adjacent2.adjacent.right);
	
}

/**
 * 检查四侧相邻颗粒的一致性
 * @param {Object} blkData - BLK数据对象
 * @param {Object} voxel1 - 第一个体素
 * @param {Object} voxel2 - 第二个体素
 * @returns {boolean} 是否一致
 */
function checkFourSideConsistency(blkData, voxel1, voxel2) {
	// 获取两个体素的相邻信息
	const adjacent1 = getVoxelAdjacentInfo(blkData, voxel1);
	const adjacent2 = getVoxelAdjacentInfo(blkData, voxel2);
	
	if (!adjacent1 || !adjacent2) {
		return false;
	}
	
	// 检查两个体素是否都有四侧相邻
	if (adjacent1.adjacentCount !== 4 || adjacent2.adjacentCount !== 4) {
		return false;
	}
	
	// 四侧相邻的颗粒在所有方向上都是一致的
	return true;
}

/**
 * 获取体素的相邻信息
 * @param {Object} blkData - BLK数据对象
 * @param {Object} voxel - 体素对象
 * @returns {Object} 相邻信息
 */
function getVoxelAdjacentInfo(blkData, voxel) {
	// 这里需要重新分析体素的相邻情况
	// 由于我们没有原始的voxelArray，我们需要从BLK数据中推断相邻信息
	
	const key = `${voxel.x},${voxel.y},${voxel.z}`;
	const data = blkData.data[key];
	
	if (!data) {
		return null;
	}
	
	const adjacentCount = data[1];
	const rotY = data[4];
	
	// 根据旋转角度推断相邻情况
	// 这是一个简化的实现，实际应用中可能需要更复杂的逻辑
	const adjacent = {
		front: false,
		back: false,
		left: false,
		right: false
	};
	
	// 根据旋转角度和相邻数量推断相邻情况
	if (adjacentCount === 3) {
		// 三侧相邻的情况
		if (rotY === 0) {
			adjacent.front = true;
			adjacent.back = true;
			adjacent.left = true;
		} else if (rotY === 90) {
			adjacent.front = true;
			adjacent.back = true;
			adjacent.right = true;
		} else if (rotY === 180) {
			adjacent.back = true;
			adjacent.left = true;
			adjacent.right = true;
		} else if (rotY === 270) {
			adjacent.front = true;
			adjacent.left = true;
			adjacent.right = true;
		}
	} else if (adjacentCount === 4) {
		// 四侧相邻的情况
		adjacent.front = true;
		adjacent.back = true;
		adjacent.left = true;
		adjacent.right = true;
	}
	
	return {
		adjacent,
		adjacentCount
	};
}


/**
 * 优化串联数据单层 - 进行颗粒合并
 * @param {Object} blockData - BLOCK数据对象
 * @param {number} layerZ - 当前层Z坐标
 */
function processBlockLayerOptimization(blockData, layerZ, oldBlkId = 'X1', newBlkId = 'X2', hideBlock = true) {
	const processed = new Set(); // 记录已处理颗粒
	// 收集当前层所有颗粒
	const layerVoxels = [];
	let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
	for (const key in blockData.data) {
		const [x, y, z] = key.split(',').map(Number);
		const [c, blkId, show] = blockData.data[key];
		if (z === layerZ && show !== 0) {
			layerVoxels.push({ x, y, z, c, key });
			if (x < minX) minX = x;
			if (x > maxX) maxX = x;
			if (y < minY) minY = y;
			if (y > maxY) maxY = y;
		}
	}
	if (layerVoxels.length === 0 || !isFinite(minX) || !isFinite(maxX) || !isFinite(minY) || !isFinite(maxY)) {
		return;
	}
	// 构建快速查找表
	const voxelMap = new Map();
	for (const v of layerVoxels) {
		voxelMap.set(`${v.x},${v.y},${v.z}`, v);
	}
	// X方向合并
	for (let y = minY; y <= maxY; y++) {
		let startX = (y % 2 === 0) ? minX : minX + 1;
		if (layerZ % 2 === 0) {
			// 分层错位算法
			startX = (y % 2 === 1) ? minX : minX + 1;
		}
		for (let x = startX; x <= maxX; x++) {
			const k1 = `${x},${y},${layerZ}`;
			const k2 = `${x+1},${y},${layerZ}`;
			if (processed.has(k1) || processed.has(k2)) continue;
			if (voxelMap.has(k1) && voxelMap.has(k2)) {
				const d1 = blockData.data[k1];
				const d2 = blockData.data[k2];
				if (d1 && d2 && d1[0] === d2[0]) { // 颜色相同
					if (hideBlock) {
						if (d2[2] !== 0) d2[2] = 0;
					} else {
						delete blockData.data[k2];
					}
					d1[1] = newBlkId;
					d1[3] = 'X';
					processed.add(k1);
					processed.add(k2);
				}
			}
		}
	}
	// Y方向合并
	for (let x = minX; x <= maxX; x++) {
		let startY = (x % 2 === 0) ? minY + 1 : minY;
		if (layerZ % 2 === 0) {
			// 分层错位算法
			startY = (x % 2 === 1) ? minY + 1 : minY;
		}
		for (let y = startY; y <= maxY; y++) {
			const k1 = `${x},${y},${layerZ}`;
			const k2 = `${x},${y+1},${layerZ}`;
			if (processed.has(k1) || processed.has(k2)) continue;
			if (voxelMap.has(k1) && voxelMap.has(k2)) {
				const d1 = blockData.data[k1];
				const d2 = blockData.data[k2];
				if (d1 && d2 && d1[0] === d2[0]) { // 颜色相同
					if (hideBlock) {
						if (d2[2] !== 0) d2[2] = 0;
					} else {
						delete blockData.data[k2];
					}
					d1[1] = newBlkId;
					d1[3] = 'Y';
					processed.add(k1);
					processed.add(k2);
				}
			}
		}
	}

	// 补充：x方向连续合并
	const processedSupplement = new Set();
	for (let y = minY; y <= maxY; y++) {
		for (let x = minX; x < maxX; x++) {
			const k1 = `${x},${y},${layerZ}`;
			const k2 = `${x+1},${y},${layerZ}`;
			if (processedSupplement.has(k1) || processedSupplement.has(k2)) continue;
			if (blockData.data[k1] && blockData.data[k2]) {
				const d1 = blockData.data[k1];
				const d2 = blockData.data[k2];
				// 只处理显示中的（show=1）、blkId=oldBlkId、颜色一样的连续颗粒
				if (d1[2] === 1 && d2[2] === 1 && d1[0] === d2[0] && d1[1] === oldBlkId && d2[1] === oldBlkId) {
					d1[1] = newBlkId;
					d1[3] = 'X';
					if (hideBlock) {
						if (d2[2] !== 0) d2[2] = 0;
					} else {
						delete blockData.data[k2];
					}
					processedSupplement.add(k1);
					processedSupplement.add(k2);
				}
			}
		}
	}
	// 补充：y方向连续合并
	for (let x = minX; x <= maxX; x++) {
		for (let y = minY; y < maxY; y++) {
			const k1 = `${x},${y},${layerZ}`;
			const k2 = `${x},${y+1},${layerZ}`;
			if (processedSupplement.has(k1) || processedSupplement.has(k2)) continue;
			if (blockData.data[k1] && blockData.data[k2]) {
				const d1 = blockData.data[k1];
				const d2 = blockData.data[k2];
				if (d1[2] === 1 && d2[2] === 1 && d1[0] === d2[0] && d1[1] === oldBlkId && d2[1] === oldBlkId) {
					d1[1] = newBlkId;
					d1[3] = 'Y';
					if (hideBlock) {
						if (d2[2] !== 0) d2[2] = 0;
					} else {
						delete blockData.data[k2];
					}
					processedSupplement.add(k1);
					processedSupplement.add(k2);
				}
			}
		}
	}

}

/**
 * 优化串联数据单层 - 进行颗粒合并
 * @param {Object} chainData - CHAIN数据对象
 * @param {number} layerZ - 当前层Z坐标
 */
function processChainLayerOptimization4(chainData, layerZ, oldBlkId = '4', newBlkId = '4X4', skip = false, hideBlock = true) {
	const processed = new Set(); // 记录已处理颗粒
	// 收集当前层所有颗粒
	const layerVoxels = [];
	let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
	for (const key in chainData.data) {
		const [x, y, z] = key.split(',').map(Number);
		const [c, blkId, show] = chainData.data[key];
		if (z === layerZ && show !== 0 && blkId === oldBlkId) {
			layerVoxels.push({ x, y, z, c, key });
			if (x < minX) minX = x;
			if (x > maxX) maxX = x;
			if (y < minY) minY = y;
			if (y > maxY) maxY = y;
		}
	}
	if (layerVoxels.length === 0 || !isFinite(minX) || !isFinite(maxX) || !isFinite(minY) || !isFinite(maxY)) {
		return;
	}
	// 构建快速查找表
	const voxelMap = new Map();
	for (const v of layerVoxels) {
		voxelMap.set(`${v.x},${v.y},${v.z}`, v);
	}
	// X方向合并
	for (let y = minY; y <= maxY; y++) {
		let startX = minX;
		if (skip) {
			startX = (y % 2 === 0) ? minX : minX + 1;
			if (layerZ % 2 === 0) {
				// 分层错位算法
				startX = (y % 2 === 1) ? minX : minX + 1;
			}
		}
		for (let x = startX; x <= maxX; x++) {
			const k1 = `${x},${y},${layerZ}`;
			const k2 = `${x+1},${y},${layerZ}`;
			const k3 = `${x+2},${y},${layerZ}`;
			const k4 = `${x+3},${y},${layerZ}`;
			if (processed.has(k1) || processed.has(k2) || processed.has(k3) || processed.has(k4)) continue;
			if (voxelMap.has(k1) && voxelMap.has(k2) && voxelMap.has(k3) && voxelMap.has(k4)) {
				const d1 = chainData.data[k1];
				const d2 = chainData.data[k2];
				const d3 = chainData.data[k3];
				const d4 = chainData.data[k4];
				if (d1 && d2 && d3 && d4 && d1[0] === d2[0] && d1[0] === d3[0] && d1[0] === d4[0]) { // 颜色相同
					if (hideBlock) {
						if (d2[2] !== 0) d2[2] = 0;
						if (d3[2] !== 0) d3[2] = 0;
						if (d4[2] !== 0) d4[2] = 0;
					} else {
						delete chainData.data[k2];
						delete chainData.data[k3];
						delete chainData.data[k4];
					}
					d1[1] = newBlkId;
					d1[3] = 'X';
					processed.add(k1);
					processed.add(k2);
					processed.add(k3);
					processed.add(k4);
				}
			}
		}
	}
	// Y方向合并
	for (let x = minX; x <= maxX; x++) {
		let startY = minY;
		if (skip) {
			startY = (x % 2 === 0) ? minY + 1 : minY;
			if (layerZ % 2 === 0) {
				// 分层错位算法
				startY = (x % 2 === 1) ? minY + 1 : minY;
			}
		}
		for (let y = startY; y <= maxY; y++) {
			const k1 = `${x},${y},${layerZ}`;
			const k2 = `${x},${y+1},${layerZ}`;
			const k3 = `${x},${y+2},${layerZ}`;
			const k4 = `${x},${y+3},${layerZ}`;
			if (processed.has(k1) || processed.has(k2) || processed.has(k3) || processed.has(k4)) continue;
			if (voxelMap.has(k1) && voxelMap.has(k2) && voxelMap.has(k3) && voxelMap.has(k4)) {
				const d1 = chainData.data[k1];
				const d2 = chainData.data[k2];
				const d3 = chainData.data[k3];
				const d4 = chainData.data[k4];
				if (d1 && d2 && d3 && d4 && d1[0] === d2[0] && d1[0] === d3[0] && d1[0] === d4[0]) { // 颜色相同
					if (hideBlock) {
						if (d2[2] !== 0) d2[2] = 0;
						if (d3[2] !== 0) d3[2] = 0;
						if (d4[2] !== 0) d4[2] = 0;
					} else {
						delete chainData.data[k2];
						delete chainData.data[k3];
						delete chainData.data[k4];
					}
					d1[1] = newBlkId;
					d1[3] = 'Y';
					processed.add(k1);
					processed.add(k2);
					processed.add(k3);
					processed.add(k4);
				}
			}
		}
	}

	// 补充：x方向连续合并
	const processedSupplement = new Set();
	for (let y = minY; y <= maxY; y++) {
		for (let x = minX; x < maxX; x++) {
			const k1 = `${x},${y},${layerZ}`;
			const k2 = `${x+1},${y},${layerZ}`;
			const k3 = `${x+2},${y},${layerZ}`;
			const k4 = `${x+3},${y},${layerZ}`;
			if (processedSupplement.has(k1) || processedSupplement.has(k2) || processedSupplement.has(k3) || processedSupplement.has(k4)) continue;
			if (chainData.data[k1] && chainData.data[k2] && chainData.data[k3] && chainData.data[k4]) {
				const d1 = chainData.data[k1];
				const d2 = chainData.data[k2];
				const d3 = chainData.data[k3];
				const d4 = chainData.data[k4];
				// 只处理显示中的（show=1）、blkId=oldBlkId、颜色一样的连续颗粒
				if (d1[2] === 1 && d2[2] === 1 && d3[2] === 1 && d4[2] === 1 && d1[0] === d2[0] && d1[0] === d3[0] && d1[0] === d4[0] && d1[1] === oldBlkId && d2[1] === oldBlkId && d3[1] === oldBlkId && d4[1] === oldBlkId) {
					d1[1] = newBlkId;
					d1[3] = 'X';
					if (hideBlock) {	
						if (d2[2] !== 0) d2[2] = 0;
						if (d3[2] !== 0) d3[2] = 0;
						if (d4[2] !== 0) d4[2] = 0;
					} else {
						delete chainData.data[k2];
						delete chainData.data[k3];
						delete chainData.data[k4];
					}
					processedSupplement.add(k1);
					processedSupplement.add(k2);
					processedSupplement.add(k3);
					processedSupplement.add(k4);
				}
			}
		}
	}
	// 补充：y方向连续合并
	for (let x = minX; x <= maxX; x++) {
		for (let y = minY; y < maxY; y++) {
			const k1 = `${x},${y},${layerZ}`;
			const k2 = `${x},${y+1},${layerZ}`;
			const k3 = `${x},${y+2},${layerZ}`;
			const k4 = `${x},${y+3},${layerZ}`;
			if (processedSupplement.has(k1) || processedSupplement.has(k2) || processedSupplement.has(k3) || processedSupplement.has(k4)) continue;
			if (chainData.data[k1] && chainData.data[k2] && chainData.data[k3] && chainData.data[k4]) {
				const d1 = chainData.data[k1];
				const d2 = chainData.data[k2];
				const d3 = chainData.data[k3];
				const d4 = chainData.data[k4];
				if (d1[2] === 1 && d2[2] === 1 && d3[2] === 1 && d4[2] === 1 && d1[0] === d2[0] && d1[0] === d3[0] && d1[0] === d4[0] && d1[1] === oldBlkId && d2[1] === oldBlkId && d3[1] === oldBlkId && d4[1] === oldBlkId) {
					d1[1] = newBlkId;
					d1[3] = 'Y';
					if (hideBlock) {
						if (d2[2] !== 0) d2[2] = 0;
						if (d3[2] !== 0) d3[2] = 0;
						if (d4[2] !== 0) d4[2] = 0;
					} else {
						delete chainData.data[k2];
						delete chainData.data[k3];
						delete chainData.data[k4];
					}
					processedSupplement.add(k1);
					processedSupplement.add(k2);
					processedSupplement.add(k3);
					processedSupplement.add(k4);
				}
			}
		}
	}

}

function processChainLayerOptimization3(chainData, layerZ, oldBlkId = '4', newBlkId = '4X3', skip = false, hideBlock = true) {
	const processed = new Set(); // 记录已处理颗粒
	// 收集当前层所有颗粒
	const layerVoxels = [];
	let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
	for (const key in chainData.data) {
		const [x, y, z] = key.split(',').map(Number);
		const [c, blkId, show] = chainData.data[key];
		if (z === layerZ && show !== 0 && blkId === oldBlkId) {
			layerVoxels.push({ x, y, z, c, key });
			if (x < minX) minX = x;
			if (x > maxX) maxX = x;
			if (y < minY) minY = y;
			if (y > maxY) maxY = y;
		}
	}
	if (layerVoxels.length === 0 || !isFinite(minX) || !isFinite(maxX) || !isFinite(minY) || !isFinite(maxY)) {
		return;
	}
	// 构建快速查找表
	const voxelMap = new Map();
	for (const v of layerVoxels) {
		voxelMap.set(`${v.x},${v.y},${v.z}`, v);
	}
	// X方向合并
	for (let y = minY; y <= maxY; y++) {
		let startX = minX;
		if (skip) {
			startX = (y % 2 === 0) ? minX : minX + 1;
			if (layerZ % 2 === 0) {
				// 分层错位算法
				startX = (y % 2 === 1) ? minX : minX + 1;
			}
		}
		for (let x = startX; x <= maxX; x++) {
			const k1 = `${x},${y},${layerZ}`;
			const k2 = `${x+1},${y},${layerZ}`;
			const k3 = `${x+2},${y},${layerZ}`;
			if (processed.has(k1) || processed.has(k2) || processed.has(k3)) continue;
			if (voxelMap.has(k1) && voxelMap.has(k2) && voxelMap.has(k3)) {
				const d1 = chainData.data[k1];
				const d2 = chainData.data[k2];
				const d3 = chainData.data[k3];
				if (d1 && d2 && d3 && d1[0] === d2[0] && d1[0] === d3[0]) { // 颜色相同
					if (hideBlock) {
						if (d2[2] !== 0) d2[2] = 0;
						if (d3[2] !== 0) d3[2] = 0;
					} else {
						delete chainData.data[k2];
						delete chainData.data[k3];
					}
					d1[1] = newBlkId;
					d1[3] = 'X';
					processed.add(k1);
					processed.add(k2);
					processed.add(k3);
				}
			}
		}
	}
	// Y方向合并
	for (let x = minX; x <= maxX; x++) {
		let startY = minY;
		if (skip) {
			startY = (x % 2 === 0) ? minY + 1 : minY;
			if (layerZ % 2 === 0) {
				// 分层错位算法
				startY = (x % 2 === 1) ? minY + 1 : minY;
			}
		}
		for (let y = startY; y <= maxY; y++) {
			const k1 = `${x},${y},${layerZ}`;
			const k2 = `${x},${y+1},${layerZ}`;
			const k3 = `${x},${y+2},${layerZ}`;
			if (processed.has(k1) || processed.has(k2) || processed.has(k3)) continue;
			if (voxelMap.has(k1) && voxelMap.has(k2) && voxelMap.has(k3)) {
				const d1 = chainData.data[k1];
				const d2 = chainData.data[k2];
				const d3 = chainData.data[k3];
				if (d1 && d2 && d3 && d1[0] === d2[0] && d1[0] === d3[0]) { // 颜色相同
					if (hideBlock) {
						if (d2[2] !== 0) d2[2] = 0;
						if (d3[2] !== 0) d3[2] = 0;
					} else {
						delete chainData.data[k2];
						delete chainData.data[k3];
					}
					d1[1] = newBlkId;
					d1[3] = 'Y';
					processed.add(k1);
					processed.add(k2);
					processed.add(k3);
				}
			}
		}
	}

	// 补充：x方向连续合并
	const processedSupplement = new Set();
	for (let y = minY; y <= maxY; y++) {
		for (let x = minX; x < maxX; x++) {
			const k1 = `${x},${y},${layerZ}`;
			const k2 = `${x+1},${y},${layerZ}`;
			const k3 = `${x+2},${y},${layerZ}`;
			if (processedSupplement.has(k1) || processedSupplement.has(k2) || processedSupplement.has(k3)) continue;
			if (chainData.data[k1] && chainData.data[k2] && chainData.data[k3]) {
				const d1 = chainData.data[k1];
				const d2 = chainData.data[k2];
				const d3 = chainData.data[k3];
				// 只处理显示中的（show=1）、blkId=oldBlkId、颜色一样的连续颗粒
				if (d1[2] === 1 && d2[2] === 1 && d3[2] === 1 && d1[0] === d2[0] && d1[0] === d3[0] && d1[1] === oldBlkId && d2[1] === oldBlkId && d3[1] === oldBlkId) {
					d1[1] = newBlkId;
					d1[3] = 'X';
					if (hideBlock) {	
						if (d2[2] !== 0) d2[2] = 0;
						if (d3[2] !== 0) d3[2] = 0;
					} else {
						delete chainData.data[k2];
						delete chainData.data[k3];
					}
					processedSupplement.add(k1);
					processedSupplement.add(k2);
					processedSupplement.add(k3);
				}
			}
		}
	}
	// 补充：y方向连续合并
	for (let x = minX; x <= maxX; x++) {
		for (let y = minY; y < maxY; y++) {
			const k1 = `${x},${y},${layerZ}`;
			const k2 = `${x},${y+1},${layerZ}`;
			const k3 = `${x},${y+2},${layerZ}`;
			if (processedSupplement.has(k1) || processedSupplement.has(k2) || processedSupplement.has(k3)) continue;
			if (chainData.data[k1] && chainData.data[k2] && chainData.data[k3]) {
				const d1 = chainData.data[k1];
				const d2 = chainData.data[k2];
				const d3 = chainData.data[k3];
				if (d1[2] === 1 && d2[2] === 1 && d3[2] === 1 && d1[0] === d2[0] && d1[0] === d3[0] && d1[1] === oldBlkId && d2[1] === oldBlkId && d3[1] === oldBlkId) {
					d1[1] = newBlkId;
					d1[3] = 'Y';
					if (hideBlock) {
						if (d2[2] !== 0) d2[2] = 0;
						if (d3[2] !== 0) d3[2] = 0;
					} else {
						delete chainData.data[k2];
						delete chainData.data[k3];
					}
					processedSupplement.add(k1);
					processedSupplement.add(k2);
					processedSupplement.add(k3);
				}
			}
		}
	}

}

function processChainLayerOptimization2(chainData, layerZ, oldBlkId = '4', newBlkId = '4X', skip = false, hideBlock = true) {
	const processed = new Set(); // 记录已处理颗粒
	// 收集当前层所有颗粒
	const layerVoxels = [];
	let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
	for (const key in chainData.data) {
		const [x, y, z] = key.split(',').map(Number);
		const [c, blkId, show] = chainData.data[key];
		if (z === layerZ && show !== 0 && blkId === oldBlkId) {
			layerVoxels.push({ x, y, z, c, key });
			if (x < minX) minX = x;
			if (x > maxX) maxX = x;
			if (y < minY) minY = y;
			if (y > maxY) maxY = y;
		}
	}
	if (layerVoxels.length === 0 || !isFinite(minX) || !isFinite(maxX) || !isFinite(minY) || !isFinite(maxY)) {
		return;
	}
	// 构建快速查找表
	const voxelMap = new Map();
	for (const v of layerVoxels) {
		voxelMap.set(`${v.x},${v.y},${v.z}`, v);
	}
	// X方向合并
	for (let y = minY; y <= maxY; y++) {
		let startX = minX;
		if (skip) {
			startX = (y % 2 === 0) ? minX : minX + 1;
			if (layerZ % 2 === 0) {
				// 分层错位算法
				startX = (y % 2 === 1) ? minX : minX + 1;
			}
		}
		for (let x = startX; x <= maxX; x++) {
			const k1 = `${x},${y},${layerZ}`;
			const k2 = `${x+1},${y},${layerZ}`;
			if (processed.has(k1) || processed.has(k2)) continue;
			if (voxelMap.has(k1) && voxelMap.has(k2)) {
				const d1 = chainData.data[k1];
				const d2 = chainData.data[k2];
				if (d1 && d2 && d1[0] === d2[0]) { // 颜色相同
					if (hideBlock) {
						if (d2[2] !== 0) d2[2] = 0;
					} else {
						delete chainData.data[k2];
					}
					d1[1] = newBlkId;
					d1[3] = 'X';
					processed.add(k1);
					processed.add(k2);
				}
			}
		}
	}
	// Y方向合并
	for (let x = minX; x <= maxX; x++) {
		let startY = minY;
		if (skip) {
			startY = (x % 2 === 0) ? minY + 1 : minY;
			if (layerZ % 2 === 0) {
				// 分层错位算法
				startY = (x % 2 === 1) ? minY + 1 : minY;
			}
		}
		for (let y = startY; y <= maxY; y++) {
			const k1 = `${x},${y},${layerZ}`;
			const k2 = `${x},${y+1},${layerZ}`;
			if (processed.has(k1) || processed.has(k2)) continue;
			if (voxelMap.has(k1) && voxelMap.has(k2)) {
				const d1 = chainData.data[k1];
				const d2 = chainData.data[k2];
				if (d1 && d2 && d1[0] === d2[0]) { // 颜色相同
					if (hideBlock) {
						if (d2[2] !== 0) d2[2] = 0;
					} else {
						delete chainData.data[k2];
					}
					d1[1] = newBlkId;
					d1[3] = 'Y';
					processed.add(k1);
					processed.add(k2);
				}
			}
		}
	}

	// 补充：x方向连续合并
	const processedSupplement = new Set();
	for (let y = minY; y <= maxY; y++) {
		for (let x = minX; x < maxX; x++) {
			const k1 = `${x},${y},${layerZ}`;
			const k2 = `${x+1},${y},${layerZ}`;
			if (processedSupplement.has(k1) || processedSupplement.has(k2)) continue;
			if (chainData.data[k1] && chainData.data[k2]) {
				const d1 = chainData.data[k1];
				const d2 = chainData.data[k2];
				// 只处理显示中的（show=1）、blkId=oldBlkId、颜色一样的连续颗粒
				if (d1[2] === 1 && d2[2] === 1 && d1[0] === d2[0] && d1[1] === oldBlkId && d2[1] === oldBlkId) {
					d1[1] = newBlkId;
					d1[3] = 'X';
					if (hideBlock) {	
						if (d2[2] !== 0) d2[2] = 0;
					} else {
						delete chainData.data[k2];
					}
					processedSupplement.add(k1);
					processedSupplement.add(k2);
				}
			}
		}
	}
	// 补充：y方向连续合并
	for (let x = minX; x <= maxX; x++) {
		for (let y = minY; y < maxY; y++) {
			const k1 = `${x},${y},${layerZ}`;
			const k2 = `${x},${y+1},${layerZ}`;
			if (processedSupplement.has(k1) || processedSupplement.has(k2)) continue;
			if (chainData.data[k1] && chainData.data[k2]) {
				const d1 = chainData.data[k1];
				const d2 = chainData.data[k2];
				if (d1[2] === 1 && d2[2] === 1 && d1[0] === d2[0] && d1[1] === oldBlkId && d2[1] === oldBlkId) {
					d1[1] = newBlkId;
					d1[3] = 'Y';
					if (hideBlock) {
						if (d2[2] !== 0) d2[2] = 0;
					} else {
						delete chainData.data[k2];
					}
					processedSupplement.add(k1);
					processedSupplement.add(k2);
				}
			}
		}
	}

}
/**
 * 获取优化后的BLK数据（包含优化处理）
 * @param {Object} chunk - 体素块对象
 * @param {boolean} optimize - 是否进行优化处理
 * @returns {Object} BLK数据对象
 */
export function getOptimizedBLKData(chunk, optimize = 1) {
	// 首先获取基础BLK数据
	const blkData = getBLKData(chunk);
	
	// 如果需要进行优化处理
	if (optimize) {
		return optimizeBLKData(blkData);
	}
	
	return blkData;
} 

/**
 * 获取优化后的CHAIN数据（包含优化处理）
 * @param {Object} chunk - 体素块对象
 * @param {boolean} optimize - 是否进行优化处理
 * @returns {Object} CHAIN数据对象
 */
export function getOptimizedCHAINData(chunk, optimize = 1) {
	// 首先获取基础CHAIN数据
	const chainData = getBLOCKData(chunk, '4');
	
	// 如果需要进行优化处理
	if (optimize) {
		return optimizeCHAINData(chainData, optimize);
	}
	
	return chainData;
} 

/**
 * 获取优化后的BLOCK数据（包含优化处理）
 * @param {Object} chunk - 体素块对象
 * @param {boolean} optimize - 是否进行优化处理
 * @returns {Object} BLOCK数据对象
 */
export function getOptimizedBLOCKData(chunk, optimize = true) {
	// 首先获取基础BLOCK数据
	const BLOCKData = getBLOCKData(chunk, 'X1');
	
	// 如果需要进行优化处理
	if (optimize) {
		return optimizeBLOCKData(BLOCKData);
	}
	
	return BLOCKData;
} 

export function getLayerChunk(chunk, layer, preLayers = 2, trim = true) {
    if (!chunk || !chunk.data || !chunk.size) return null
    // console.error('getLayerChunk', chunk, layer)
    layer = layer || 1
    const targetZ = layer - 1 // layer=1 对应 z=0

    // 检查目标层是否在有效范围内
    if (targetZ < 0 || targetZ >= chunk.size.z) return null

    const data = chunk.data
    const size = chunk.size
    const layerVoxels = []

    // 遍历所有体素数据，筛选出目标层的体素
    for (let i = 0; i < data.length; i += 4) {
      const x = data[i]
      const y = data[i + 1]
      const z = data[i + 2]
      const colorIndex = data[i + 3]

      // 如果体素在目标层或其下方 preLayers 层内，添加到结果中
      if (targetZ >= 0) {
        const maxDepth = Math.min(preLayers || 0, targetZ)
        for (let d = 0; d <= maxDepth; d++) {
          if (z === targetZ - d) {
            const newZ = maxDepth - d
            layerVoxels.push(x, y, newZ, colorIndex)
          }
        }
      }
    }
    // 创建新的层数据块
    let layerChunk = {
      data: new Uint8Array(layerVoxels),
      size: {
        x: size.x,
        y: size.y,
        z: (Math.min(preLayers || 0, targetZ) + 1)
      },
      palette: chunk.palette ? [...chunk.palette] : null
    }
    if (trim) layerChunk = trimVoxels(layerChunk)
    return layerChunk
}

// 获取体素块调色板
export function getChunkPaletteArr(chunk) {
    if (!chunk || !chunk.palette) return []
    const paletteObj = {}
    for (let i = 0; i < chunk.palette.length; i++) {
      if (chunk.palette[i]) {
        const color = getVoxelHexColor(chunk.palette[i])
        paletteObj[color] = true
      }
    }
    return Object.keys(paletteObj)
}

// voxelColor 是 32位无符号整数 格式，提取为 #RRGGBB
export function getVoxelHexColor(voxelColor) {
    if (voxelColor == null) return ''
    const r = (voxelColor >> 0) & 0xff
    const g = (voxelColor >> 8) & 0xff
    const b = (voxelColor >> 16) & 0xff
    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`.toUpperCase()
}

 // 将 #RRGGBB 转换为 32位无符号整数 （alpha 固定为 0xFF）
export function getVoxelColor(hexColor) {
    if (!hexColor) return 0
    let h = hexColor.trim().toUpperCase()
    if (h[0] === '#') h = h.slice(1)
    const r = parseInt(h.slice(0, 2), 16) & 0xFF
    const g = parseInt(h.slice(2, 4), 16) & 0xFF
    const b = parseInt(h.slice(4, 6), 16) & 0xFF
    return ((r) | (g << 8) | (b << 16) | (0xFF << 24)) >>> 0
}
// 生成 VOX 文件格式的 Blob 对象
export function getVOXFileBlob(chunks, diyType = 'vox', cb) {
	const generateVOXBuffer = (chunks) => {
		if (!chunks || chunks.length === 0) return new ArrayBuffer(0)

		// VOX 文件头
		const header = new ArrayBuffer(8)
		const headerView = new DataView(header)
		headerView.setUint32(0, 0x20584F56, true) // 'VOX ' (little endian)
		// TODO: 150=体素模型 151=串联积木模型 152=乐高积木模型
		if (diyType === 'chain_brick') {
			headerView.setUint32(4, 151, true) // version 151
		} else if (diyType === 'lego_brick') {
			headerView.setUint32(4, 152, true) // version 152
		} else {
			headerView.setUint32(4, 150, true) // version 150
		}
		// 处理调色板去重和颜色索引重映射
		let optimizedPalette = null
		let colorIndexMap = null

		// 如果第一个chunk有调色板，进行去重优化
		if (chunks.length > 0 && chunks[0].palette && Array.isArray(chunks[0].palette)) {
			const paletteOptimization = optimizePalette(chunks[0].palette)
			optimizedPalette = paletteOptimization.palette
			colorIndexMap = paletteOptimization.colorIndexMap
		}

		// 收集所有数据块
		const chunkBuffers = []
		let totalSize = 0

		for (let i = 0; i < chunks.length; i++) {
			const chunk = chunks[i]
			if (!chunk || !chunk.data || !chunk.size) {
				console.warn('Invalid chunk at index', i, chunk)
				continue
			}

			// 验证数据完整性
			if (chunk.data.length % 4 !== 0) {
				console.warn('Invalid voxel data length at chunk', i, chunk.data.length)
				continue
			}

			// SIZE chunk
			const sizeChunk = createSIZEChunk(chunk.size)
			chunkBuffers.push(sizeChunk)
			totalSize += sizeChunk.byteLength

			// XYZI chunk - 使用优化后的颜色索引
			const optimizedData = colorIndexMap ? remapVoxelColors(chunk.data, colorIndexMap) : chunk.data
			const xyziChunk = createXYZIChunk(optimizedData)
			chunkBuffers.push(xyziChunk)
			totalSize += xyziChunk.byteLength

			// RGBA palette chunk (only for first chunk)
			if (i === 0 && optimizedPalette) {
				const paletteChunk = createRGBAChunk(optimizedPalette)
				chunkBuffers.push(paletteChunk)
				totalSize += paletteChunk.byteLength
			}
		}

		// 创建最终缓冲区
		const result = new ArrayBuffer(header.byteLength + totalSize)
		const resultView = new Uint8Array(result)
		let offset = 0

		// 复制头部
		resultView.set(new Uint8Array(header), offset)
		offset += header.byteLength

		// 复制所有数据块
		for (let i = 0; i < chunkBuffers.length; i++) {
			const chunkBuffer = chunkBuffers[i]
			if (offset + chunkBuffer.byteLength > result.byteLength) {
				console.error('Buffer overflow at chunk', i, 'offset:', offset, 'chunk size:', chunkBuffer.byteLength, 'total size:', result.byteLength)
				break
			}
			resultView.set(new Uint8Array(chunkBuffer), offset)
			offset += chunkBuffer.byteLength
		}

		return result
	}

	// 创建 SIZE 数据块
	const createSIZEChunk = (size) => {
		const buffer = new ArrayBuffer(24) // 4 + 4 + 4 + 12 (id + size + childChunks + data)
		const view = new DataView(buffer)
		let offset = 0

		// Chunk ID: 'SIZE'
		view.setUint8(offset++, 0x53) // S
		view.setUint8(offset++, 0x49) // I
		view.setUint8(offset++, 0x5A) // Z
		view.setUint8(offset++, 0x45) // E

		// Chunk size: 12 bytes (3 * 4)
		view.setUint32(offset, 12, true)
		offset += 4

		// Child chunks: 0
		view.setUint32(offset, 0, true)
		offset += 4

		// Size data: x, y, z (12 bytes total)
		view.setUint32(offset, size.x, true)
		offset += 4
		view.setUint32(offset, size.y, true)
		offset += 4
		view.setUint32(offset, size.z, true)

		return buffer
	}

	// 创建 XYZI 数据块
	const createXYZIChunk = (data) => {
		// 先计算非透明体素数量
		let visibleVoxels = 0
		for (let i = 0; i < data.length; i += 4) {
			if (data[i + 3] !== 0) visibleVoxels++
		}
		
		const dataSize = 4 + visibleVoxels * 4 // 4 bytes for numVoxels + visibleVoxels * 4 bytes for voxel data
		const buffer = new ArrayBuffer(12 + dataSize) // 4 + 4 + 4 + dataSize (id + size + childChunks + data)
		const view = new DataView(buffer)
		let offset = 0

		// Chunk ID: 'XYZI'
		view.setUint8(offset++, 0x58) // X
		view.setUint8(offset++, 0x59) // Y
		view.setUint8(offset++, 0x5A) // Z
		view.setUint8(offset++, 0x49) // I

		// Chunk size: dataSize
		view.setUint32(offset, dataSize, true)
		offset += 4

		// Child chunks: 0
		view.setUint32(offset, 0, true)
		offset += 4

		// Number of visible voxels
		view.setUint32(offset, visibleVoxels, true)
		offset += 4

		// Voxel data: x, y, z, colorIndex (只包含非透明体素)
		for (let i = 0; i < data.length; i += 4) {
			if (offset + 4 > buffer.byteLength) {
				console.error('XYZI chunk buffer overflow at voxel', i / 4, 'offset:', offset, 'buffer size:', buffer.byteLength)
				break
			}
			const colorIndex = data[i + 3]
			// 根据VOXLoader逻辑，调色板数组索引0是透明色，索引1-256是实际颜色
			// 体素数据中的颜色索引直接对应调色板数组索引
			// 只处理非透明体素（颜色索引不为0）
			if (colorIndex === 0) continue
			
			view.setUint8(offset++, data[i])     // x
			view.setUint8(offset++, data[i + 1]) // y
			view.setUint8(offset++, data[i + 2]) // z
			view.setUint8(offset++, colorIndex)  // colorIndex (1-256，对应调色板数组索引1-256)
		}

		return buffer
	}

	// 创建 RGBA 调色板数据块
	const createRGBAChunk = (palette) => {
		const buffer = new ArrayBuffer(12 + 256 * 4) // 4 + 4 + 4 + 256 * 4
		const view = new DataView(buffer)
		let offset = 0

		// Chunk ID: 'RGBA'
		view.setUint8(offset++, 0x52) // R
		view.setUint8(offset++, 0x47) // G
		view.setUint8(offset++, 0x42) // B
		view.setUint8(offset++, 0x41) // A

		// Chunk size: 256 * 4
		view.setUint32(offset, 256 * 4, true)
		offset += 4

		// Child chunks: 0
		view.setUint32(offset, 0, true)
		offset += 4

		// Palette data: 256 colors (RGBA)
		// 根据VOXLoader解析逻辑，调色板数组索引0为透明色，索引1-256为实际颜色
		// 但VOX文件格式中，调色板数据直接存储256个颜色（索引0-255）
		for (let i = 0; i < 256; i++) {
			if (offset + 4 > buffer.byteLength) {
				console.error('RGBA chunk buffer overflow at color', i, 'offset:', offset, 'buffer size:', buffer.byteLength)
				break
			}
			// VOX文件中的调色板索引0-255对应调色板数组索引1-256
			// 调色板数组索引0是透明色，索引1-256是实际颜色
			const color = palette[i + 1] || 0
			// 根据VOXUtils.js中的颜色格式：R(0-7位), G(8-15位), B(16-23位), A(24-31位)
			// VOX文件格式要求RGBA顺序存储
			view.setUint8(offset++, (color >> 0) & 0xFF)  // R
			view.setUint8(offset++, (color >> 8) & 0xFF)  // G  
			view.setUint8(offset++, (color >> 16) & 0xFF) // B
			view.setUint8(offset++, (color >> 24) & 0xFF) // A
		}

		return buffer
	}

	// 优化调色板：去重并创建颜色索引映射
	const optimizePalette = (originalPalette) => {
		// 创建颜色到新索引的映射
		const colorToIndex = new Map()
		const uniqueColors = []
		const colorIndexMap = new Array(257) // 索引0-256，对应调色板数组索引0-256
		
		// 索引0始终为透明色
		colorIndexMap[0] = 0
		uniqueColors.push(0)
		
		// 遍历原始调色板，去重
		for (let i = 1; i < originalPalette.length; i++) {
			const color = originalPalette[i] || 0
			if (!colorToIndex.has(color)) {
				// 新颜色，添加到唯一颜色列表
				const newIndex = uniqueColors.length
				uniqueColors.push(color)
				colorToIndex.set(color, newIndex)
			}
			// 记录原始索引到新索引的映射
			colorIndexMap[i] = colorToIndex.get(color)
		}
		
		// 确保调色板有256个颜色（不足的用0填充）
		while (uniqueColors.length < 256) {
			uniqueColors.push(0)
		}
		
		return {
			palette: uniqueColors,
			colorIndexMap: colorIndexMap
		}
	}

	// 重新映射体素数据中的颜色索引
	const remapVoxelColors = (voxelData, colorIndexMap) => {
		const newData = new Uint8Array(voxelData.length)
		
		for (let i = 0; i < voxelData.length; i += 4) {
			// 复制 x, y, z 坐标
			newData[i] = voxelData[i]     // x
			newData[i + 1] = voxelData[i + 1] // y
			newData[i + 2] = voxelData[i + 2] // z
			
			// 重新映射颜色索引
			const originalColorIndex = voxelData[i + 3]
			const newColorIndex = colorIndexMap[originalColorIndex] || 0
			newData[i + 3] = newColorIndex
		}
		
		return newData
	}

	// 导出为 Blob 对象
	const buffer = generateVOXBuffer(chunks)
	const blob = new Blob([buffer], { type: 'application/octet-stream' })
	cb && cb(blob, diyType)
	return blob
}